"use client";

import { createContext, type PropsWithChildren, useContext } from "react";
import type { AccordionitemStoryblok } from "@/generated/sb/sb-types";

type ProductSizeGuideContext = {
  sizeChartItems: AccordionitemStoryblok[] | undefined;
};

const ProductSizeGuideContext = createContext<null | ProductSizeGuideContext>(
  null,
);

export const ProductSizeGuideProvider = ({
  children,
  sizeChartItems,
}: PropsWithChildren<Pick<ProductSizeGuideContext, "sizeChartItems">>) => {
  return (
    <ProductSizeGuideContext.Provider value={{ sizeChartItems }}>
      {children}
    </ProductSizeGuideContext.Provider>
  );
};

export const useProductSizeGuide = () => {
  const ctx = useContext(ProductSizeGuideContext);

  if (ctx === null) {
    throw new Error(
      "useProductSizeGuide must be used within a ProductSizeGuideProvider",
    );
  }

  return ctx;
};
